import { render, staticRenderFns } from "./WeekStrip.vue?vue&type=template&id=5924093c&scoped=true&"
import script from "./WeekStrip.ts?vue&type=script&lang=ts&"
export * from "./WeekStrip.ts?vue&type=script&lang=ts&"
import style0 from "./WeekStrip.scss?vue&type=style&index=0&id=5924093c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5924093c",
  null
  
)

export default component.exports